import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 67 — HubSpot cluster service links.
 *
 * Every Batch 67 article routes its primary commercial link to
 * /hubspot-revops-architect. The answer-first leads in batch67Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /hubspot-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH67_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hubspot-onboarding-mistakes": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no lifecycle stages is a portal the team runs on a spreadsheet/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-for-saas-companies": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no churn signal is a portal the team runs on a retention report/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-for-agencies": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal that mixes the agency and the client is a portal the bookkeeper cannot reconcile/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-revops-implementation-guide": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no shared deal definition is a portal the forecast cannot trust/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-data-model-architecture": {
    url: "/hubspot-revops-architect",
    anchor: /portal with no associations is a portal the report cannot join/i,
    label: "hire a HubSpot RevOps architect",
  },
};
